import { gql } from 'graphql-request';

export const GET_MY_INCOMING_INVITATIONS_COUNT = gql`
  query CoreOrganizations {
    coreOrganizationInvitations {
      count(filter: { isIncoming: true, statuses: sent })
    }
  }
`;
